/**
 * Converts camel case string to snake case string. For example: thisStringExample => this-string-example, ThisStringExample => this-string-example, this.string.example => this-string-example, this--stringExample => this-string-example
 * @param {String} camelString camelCaseString
 * @return {String}
 */
export function camelCaseToKebabCase(camelString) {
    return camelString
        .replace(/ /g, '')
        .replace(/[A-Z]/g, (letter) => `-${letter.toLowerCase()}`)
        .replace(/^-/, '')
        .replace('.', '-')
        .replace('--', '-')
        .replace(/ä/g, "ae")
        .replace(/ö/g, "oe")
        .replace(/ü/g, "ue")
        .replace(/Ä/g, "ae")
        .replace(/Ö/g, "oe")
        .replace(/Ü/g, "ue")
        .replace(/ß/g, "ss");
}

/**
 * Returns true if given string is undefined, null or empty.
 * @param {String | null} string
 * @return {Boolean}
 */
export function isNullOrEmpty(string) {
    return string === undefined || string === null || string === '';
}

/**
 * Format number by parsing it to a kB/MB/GB/TB.
 * @param bytes Number. Original value
 * @param decimals Number. Number of digits after the the comma in the end result
 * @returns {string}
 */
export function formatBytes(bytes, decimals = 2) {
    if (bytes === 0) return '0 B';

    const units = ['B', 'kB', 'MB', 'GB', 'TB'];
    const index = Math.floor(Math.log(bytes) / Math.log(1024));

    return `${(bytes / Math.pow(1024, index)).toFixed(decimals)} ${units[index]}`;
}